import { render } from "./ViewIndividualReport.vue?vue&type=template&id=32624cd0&scoped=true"
import script from "./ViewIndividualReport.vue?vue&type=script&lang=js"
export * from "./ViewIndividualReport.vue?vue&type=script&lang=js"

import "./ViewIndividualReport.vue?vue&type=style&index=0&id=32624cd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32624cd0"]])

export default __exports__